// extracted by mini-css-extract-plugin
module.exports = {"container":"styles__container___1LYTP","icon":"styles__icon___35kVr","title":"styles__title___v2Ddb","description":"styles__description___njVI9","action":"styles__action___UyW7a"};